import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { startLoading, endLoading } from '../../actions/loadingAction';
import { isNullOrEmpty, translate } from '../../utils/util';
import LoadUnloadService from '../../services/LoadUnloadService';
import { Collapsible } from '../../components/UI/ComponentsUI';
import SupplierService from '../../services/SupplierService';
import LoadConfirmation from './LoadConfirmation/LoadConfirmation';
import LoadAddItem from './LoadAddItem';
import LoadUpdateItem from './LoadUpdateItem';
import ConfirmModalUI from '../../components/UI/ConfirmModalUI';

const LoadItem = (props) => {
  const [selectData, setselectData] = useState({});
  const [model, setModel] = useState({ acaoConfirm: '', index: null });
  const [openModal, setOpenModal] = useState(false);

  const verifyShowTransportOrder = (rackTypeCode, supplierId, callback) => {
    if (!isNullOrEmpty(rackTypeCode) && !isNullOrEmpty(supplierId)) {
      props.getIsPackingFCM(rackTypeCode, supplierId, (data) => {
        callback(data);
      });
    }
  }

  const removeItem = (item) => {
    model.acaoConfirm = translate('delete', 'general');
    model.index = item.id;
    setModel(model);
    setOpenModal(true);
  }

  const submitConfirm = () => {
    setOpenModal(false);
    if (model.acaoConfirm === 'Confirmar') {
      //submit();
    } else if (model.acaoConfirm === 'Excluir') {
      props.deleteLoadItem(model.index);
      props.removeConfirmationMdrList(model.index);
      setselectData({})
    }
  }

  const updateItem = (data) => {
    const item = props.confirmationList.find(f => f.id === data?.id)
    if (selectData?.id === item.id) {
      setselectData({})
    } else {
      var element = document.getElementById(item.id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      setselectData(item);
    }
  }

  const renderItem = (data, index) => {
    return (
      <Collapsible
        actions={
          [
            {
              func: () => removeItem(data),
              actionicon: "mdi mdi-36px mdi-delete"
            },
            {
              func: () => {
                updateItem(data)
              },
              open: true,
              actionicon: "mdi mdi-36px mdi-circle-edit-outline",
              actionIconColor: `${selectData.id === data.id ? "green" : "blue"}`
            },
            // {
            //   actionicon: `mdi mdi-36px mdi-numeric-${index}`,
            //   actionIconColor: `blue`
            // },
          ]
        }
        id={`collapsible-${data.id}`}
        close="true"
        header={`Vasilhame ${data.rackType?.code || ""}`}
        body={
          <LoadUpdateItem
            verifyShowTransportOrder={verifyShowTransportOrder}
            index
            update={!props?.mvm?.load?.indSentAe && selectData.id === data.id}
            clearSelectItem={() => setselectData({})}
            data={data} />
        }
      />
    )
  }

  return (
    <>
      <div className="container-fluid" style={{ paddingTop: '0px' }}>
        <div className="container">
          {!props?.mvm?.load?.indSentAe &&
            <Collapsible
              id="collapsible2"
              header={translate('load-mdr', 'load-unload')}
              body={
                <LoadAddItem
                  clearSelectItem={() => setselectData({})}
                  verifyShowTransportOrder={verifyShowTransportOrder}
                  {...props} />
              }
            />
          }
          {
            props.confirmationList.filter.length > 0 &&
            <div style={{ paddingBlockEnd: '10px' }}>
              {
                props.confirmationList.sort((a, b) => {
                  if (a.id < b.id) { return 1; }
                  if (a.id > b.id) { return -1; }
                  return 0;
                }).filter(f => !f.data?.excluded).map((data, index) => {
                  return renderItem(data, index + 1);
                })
              }
              <LoadConfirmation disableList="true" {...props} />
            </div>
          }
        </div>
      </div >
      <ConfirmModalUI
        open={openModal}
        showCancel="true"
        id="confirmModalFinalize"
        data={{
          title: `${translate('delete', 'general')}`,
          message: <>
            {translate('confirm-delete', 'load-unload')}
          </>
        }}
        onConfirm={() => {
          setOpenModal(false)
          submitConfirm()
        }}
        onCancel={() => setOpenModal(false)}
        onClose={() => setOpenModal(false)}
        btnCancel={translate('cancel', 'general')}
        btnConfirm={translate('confirm', 'general')}
      />
    </ >
  );
};


const mapStateToProps = (state) => {
  return {
    rackTypeList: state.loadUnloadReducer.rackTypeList,
    supplierList: state.supplierReducer.supplierList,
    shedObj: state.loadUnloadReducer.shedObj,
    user: state.userReducer.user,
    confirmationList: state.loadUnloadReducer.confirmationList,
    mvm: state.loadUnloadReducer.mvm
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadMdrTypes: (callback) => {
      dispatch(LoadUnloadService.getMdrTypes(callback));
    },
    loadSupplier: (text, plantId, callback) => {
      dispatch(SupplierService.getSuppliers(text, plantId, callback));
    },
    getIsPackingFCM: (rackTypeCode, supplierCode, callback) => {
      dispatch(LoadUnloadService.getIsPackingFCM(rackTypeCode, supplierCode, callback));
    },
    insertConfirmationMdrList: (item) => {
      dispatch(LoadUnloadService.insertConfirmationMdrList(item));
    },
    removeConfirmationMdrList: (item) => {
      dispatch(LoadUnloadService.removeConfirmationMdrList(item));
    },
    deleteLoadItem: (item, callback) => {
      dispatch(LoadUnloadService.deleteLoadItem(item, callback));
    },
    showLoading: () => {
      dispatch(startLoading());
    },
    hideLoading: () => {
      dispatch(endLoading());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LoadItem));
